
<template>
  <div>
    <el-form label-width="120px" class="query-form">
      <el-row gutter="10">
        <el-col :span="4">
          <el-form-item label="开始日期" class="form-item">
            <el-date-picker v-model="beginTime" type="date" placeholder="选择开始日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="结束日期" class="form-item">
            <el-date-picker v-model="endTime" type="date" placeholder="选择结束日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="汇总层级" class="form-item">
            <el-select v-model="timeLevel" placeholder="选择汇总层级">
              <el-option label="DAY" value="DAY"></el-option>
              <el-option label="ALL" value="ALL"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="form-item">
            <el-button type="primary" @click="fetchData" class="query-button">查询</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="form-item">
            <el-button type="success" @click="exportToExcel" class="export-button">导出excel</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="table-wrapper">
      <el-table
        :data="responseData"
        border
        style="width: 100%;"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column prop="fdate" label="日期" sortable></el-table-column>
        <el-table-column prop="advName" label="二代名称" sortable></el-table-column>
        <el-table-column prop="edowner_id" label="二代ownerid" sortable></el-table-column>
        <el-table-column prop="owner_name" label="三代名称" sortable></el-table-column>
        <el-table-column prop="owner_id" label="三代ownerid" sortable></el-table-column>
        <el-table-column prop="cost" label="消费" sortable :formatter="formatCost"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import sha1 from 'sha1'; // 确保你安装了sha1库
import * as XLSX from 'xlsx'; // 导入xlsx库
export default {
  data() {
    return {
      beginTime: "", // 开始时间
      endTime: "",   // 结束时间
      timeLevel: "DAY", // 默认为DAY
      responseData: [] // 用于存储接口返回的数据
    };
  },

  methods: {

    formatCost(row, column, cellValue) {
      return Number(cellValue).toFixed(2);
    },
    // Element Plus 底部汇总方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总';
          return;
        }
        if (column.property === 'cost') {
          const total = data.reduce((sum, row) => sum + Number(row.cost || 0), 0);
          sums[index] = total.toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    exportToExcel() {
      // 先计算总消费
      const totalCost = this.responseData.reduce((sum, item) => sum + Number(item.cost || 0), 0);

      // 选择要导出的字段，并在最后添加汇总行
      const exportData = [
        ...this.responseData.map(item => ({
          日期: item.fdate,
          二代名称: item.advName,
          二代ownerid: item.edowner_id,
          三代名称: item.owner_name,
          三代ownerid: item.owner_id,
          消费: Number(item.cost) // 确保是数字格式
        })),
        {
          日期: '汇总', // 汇总行标记
          二代名称: '',
          二代ownerid: '',
          三代名称: '',
          三代ownerid: '',
          消费: totalCost // 总消费
        }
      ];

      // 创建工作簿
      const wb = XLSX.utils.book_new();

      // 将数据转换为工作表
      const ws = XLSX.utils.json_to_sheet(exportData, {
        header: ["日期", "二代名称", "二代ownerid", "三代名称", "三代ownerid", "消费"],
        skipHeader: false
      });

      // 设置列宽
      ws['!cols'] = [
        { wch: 15 }, // 日期
        { wch: 20 }, // 二代名称
        { wch: 35 }, // 二代ownerid
        { wch: 20 }, // 三代名称
        { wch: 35 }, // 三代ownerid
        { wch: 15 }  // 消费
      ];

      // 设置数字格式（包括汇总行）
      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let R = 1; R <= range.e.r; ++R) { // 从第一行数据开始（不含表头）
        const costCellAddress = XLSX.utils.encode_cell({ r: R, c: 5 }); // F列
        if (ws[costCellAddress]) {
          ws[costCellAddress].t = 'n'; // 数字类型
          ws[costCellAddress].z = '0.00'; // 两位小数
        }
      }

      // 添加工作表到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Data');

      // 导出 Excel
      XLSX.writeFile(wb, 'data_export.xlsx');
    },
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); // 月份从0开始
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}${month}${day}`; // 返回格式为YYYYMMDD
    },
    generateToken(owner_id, api_id, api_key) {
      const time_stamp = Math.floor(Date.now() / 1000); // 当前时间戳
      const sign = sha1(api_id + api_key + time_stamp);
      const tokenString = `${owner_id},${api_id},${time_stamp},${sign}`;
      const token = btoa(tokenString); // 使用Base64编码
      return token;
    },
    fetchData() {
      // 示例数据，您可以根据实际情况进行调整
      const advertisers = [
        {
          advName: "SMBSY-DD表单-XXL", // 广告主名称
          owner_id: "1000166356",
          api_id: "f00927ea6e0641ec9d06752695cc9ebc",
          api_key: "fa1c6a08754f48b49345800a2f96bc3a"
        },
        {
          advName: "SMBSY-WO表单-二代", // 广告主名称
          owner_id: "1000344983",
          api_id: "9687a728ec4b4144b7311579e40aaeba",
          api_key: "94d051ac3a984ac9b5fc68f89ba13f4f"
        },
        {
          advName: "SMBSY-WO表单2-二代", // 广告主名称
          owner_id: "1000373105",
          api_id: "f65cc3c4f465410d816d9fae3033aa47",
          api_key: "0d424a45ab5c452e9cbe30ecdb0932aa"
        },
        {
          advName: "SMBHEI-金源成商贸-二代", // 广告主名称
          owner_id: "1000092071",
          api_id: "9861841bfd744bd5a8649867b89a0597",
          api_key: "44318c6155d642fbbbef012d4b06d2f8"
        },
        {
          advName: "SMBSY-VC快应用-二代", // 广告主名称
          owner_id: "1000320891",
          api_id: "d7dbdba0a8ee4c159d633edc63b7b000",
          api_key: "7a5ad11669754e4ba61f42d78b6ba974"
        },
        {
          advName: "SMBSY-ZJWC-二代", // 广告主名称
          owner_id: "1000192758",
          api_id: "059f6cba435a4e14ae329a53725a8f0c",
          api_key: "99ab12f1641c424b9a8936c6a57ce699"
        },
        {
          advName: "SMBHZ-关瑞-二级", // 广告主名称
          owner_id: "1000073340",
          api_id: "f2094cd1ac4f4fbda5978c5a18045c2b",
          api_key: "93a17917d40847b58df89a6fd53fc906"
        },
        {
          advName: "SMBHZ-日进斗金-二级", // 广告主名称
          owner_id: "1000221619",
          api_id: "eda52dda31b74447bbf14fc21c1eec33",
          api_key: "91f696fe91ad46a7837b63993db782c4"
        },
        {
          advName: "SMBSZ-起量666（二代）-XXL", // 广告主名称
          owner_id: "1000147121",
          api_id: "7e906eb7e9a8435eaca7080479b6b5d6",
          api_key: "8fb153eb21a940beb282abde156d53d2"
        },
        {
          advName: "SMBHEF-KL（莲雾lrr）-二级", // 广告主名称
          owner_id: "1000215233",
          api_id: "0652c831e66947b7b862a67bb22095ad",
          api_key: "156978ee7afc45cda5c522bb56e5517f"
        },

        {
          advName: "SMBHEF-KL（莲雾）-二级", // 广告主名称
          owner_id: "1000237501",
          api_id: "7a7e15ae9b604296a9b00b9c1d76940f",
          api_key: "a895ced6510f4d90a2103268b50f94b4"
        },
        {
          advName: "SMBHEF-K（星乐园-2）-二级", // 广告主名称
          owner_id: "1000408002",
          api_id: "a1b1711a9c994ff8a06aeb1c4166120a",
          api_key: "1fea7e26fc5b4aa1aaf6c7bb7a41ef7f"
        },
        {
          advName: "SMBNJ-南京飞飞-二级", // 广告主名称
          owner_id: "1000232846",
          api_id: "ef4f0965a39f4929855ed2d3b02c0ecb",
          api_key: "0e47b3c12eb34f3a9f15be26b57b980a"
        },
        {
          advName: "SMBHEF-K（追书神器-2）-二级", // 广告主名称
          owner_id: "1000477947",
          api_id: "81a3377973ab4c90b7e99b53ea99c638",
          api_key: "020a487793b1409ba7e8e6e5215c8bfb"
        },
        {
          advName: "SMBHEF-L（莲雾拉活）-二级", // 广告主名称
          owner_id: "1000522531",
          api_id: "fc89b3a916af4976b4efbfc2c5752df3",
          api_key: "2a1499590f4c42b49e2c786ce4c46ea2"
        },
        {
          advName: "SMBHEF-X（莲雾）-二级", // 广告主名称
          owner_id: "1000570166",
          api_id: "f7ae972025674222a4b2c637acc5dcbd",
          api_key: "7196995d36af463b9e98cf5bbb23f775"
        },
        {
          advName: "SMBHEF-K0（WO快应用-lw）-二级", // 广告主名称
          owner_id: "1000580831",
          api_id: "17681b13ea2a493480a684f41a1fc91c",
          api_key: "82cfb85e30f1490bb9e087a1b930c0ef"
        },
        {
          advName: "力天-微驰互动-二代", // 广告主名称
          owner_id: "1000659972",
          api_id: "bf1a255586f24c169db0fac9004e4854",
          api_key: "256cb953fdce4da79be7be3b40430dac"
        },
        {
          advName: "志隆-二代-浙江微弛", // 广告主名称
          owner_id: "1000659564",
          api_id: "f9b0d62e8aa34d50ba96e83286382a42",
          api_key: "43fdc5d9786742f38169746d23536048"
        },
        {
          advName: "SMBSZ-玄学爆发（二代）-XXL", // 广告主名称
          owner_id: "1000521661",
          api_id: "7c0205f5ac45433d97350e6c4d636356",
          api_key: "224338e65d754ef3ac88cc520c61098a"
        },

        {
          advName: "YM-ZJ微驰-拉新-二级", // 广告主名称
          owner_id: "1000772377",
          api_id: "74379bc2617f48f4ad2bfa6399f2d638",
          api_key: "e88d364de05c48e3ac3bbb51a4ba6a8e"
        },
        {
          advName: "YM-ZJ微驰-拉活-二级", // 广告主名称
          owner_id: "1000772386",
          api_id: "4be34af93f85492f8ecbb2f9b572de7c",
          api_key: "35b2ff8da13b422e9505d41bb3cf89f2"
        },

        {
          advName: "SMBJX-日薪月亿-二级", // 广告主名称
          owner_id: "1000945649",
          api_id: "21ecc51d64de4b66bf9318e4d59dc01e",
          api_key: "25e31a66ba634bca9ad19c7104aa3013"
        },
        {
          advName: "SMBHUB-ZJ端口-二级", // 广告主名称
          owner_id: "1000930947",
          api_id: "c161801997694c3ab7430a27c4b3ad9a",
          api_key: "adf42a81deb24aa69395419d0a1faa7a"
        },
        {
          advName: "爱客美-二代-微驰互动", // 广告主名称
          owner_id: "1001123153",
          api_id: "f032e296fa924b07b36abb738bf82caf",
          api_key: "7fc7bd8baebf405284e74a898c02e4da"
        },





        // 可以添加更多的广告主数据
      ];
      const zzh = [
        {
          advName: "HL-微驰互动-二代-CPA", // 广告主名称
          owner_id: "1001127104",
          api_id: "274c15d04f45407997e899a439097025",
          api_key: "7a12fdeb147a4bb7a538131008733b50"
        },
        {
          advName: "CUE-微驰互动-二代-CPS", // 广告主名称
          owner_id: "1001133919",
          api_id: "0d542fddb3b84e4c8684aa9f6352eebd",
          api_key: "b8f40f544c2842b78d82677948e1250c"
        },


        {
          advName: "SXCPA-微驰-商店二级-cpa", // 广告主名称
          owner_id: "1001121812",
          api_id: "e48026e0cdc644d7b64e7441ac5175a5",
          api_key: "446bd835d91a4f1a87f764cf7567f903"
        },
        // {
        //   advName: "微驰互动-二代", // 广告主名称
        //   owner_id: "1001156946",
        //   api_id: "2e82baccc62a43ecbff8617271105a3d",
        //   api_key: "5be6abd0a35b429b84b62022fd042150"
        // },

        {
          advName: "WB-浙江微驰(买量-cps)-二代", // 广告主名称
          owner_id: "1001154688",
          api_id: "f5ef858aa3c046faa7a89fee11e77585",
          api_key: "cec345146dd0451982a9f35ceae95eb8"
        },
        {
          advName: "SMBHEF-梧桐小说lhm-三级", // 广告主名称
          owner_id: "1000464389",
          api_id: "44c42105a71e41a08e18c9b1eab1b0d5",
          api_key: "353ade368e4a488cb58a711bb3a9f5d6"
        },
        {
          advName: "SMBHEF-健食指南lhm-三级", // 广告主名称
          owner_id: "1000464390",
          api_id: "67c1434cd81b49fb95832173330f7430",
          api_key: "04f0a7b1c480441f94a0180668c43ed0"
        },
        {
          advName: "SMBHEF-超值Golhm-三级", // 广告主名称
          owner_id: "1000464392",
          api_id: "81df7d850e9b4e90bf32cb257b4a15f5",
          api_key: "53782c7dffbd45c78abfd2db37dfb5de"
        },
        {
          advName: "SMBHEF-菠萝手机小帮手", // 广告主名称
          owner_id: "1000464393",
          api_id: "2cdf77a0c1954f98993d0c0d5431f236",
          api_key: "a2b03722295a41ef869871c10e39b42a"
        },
        {
          advName: "SMBHEF-吉祥天气lhm-三级", // 广告主名称
          owner_id: "1000476229",
          api_id: "a7aecdab41cb4248981a1f4473e7f488",
          api_key: "ff3ac2ea41e24c14b5317dbb59105bc7"
        },
        {
          advName: "SMBHEF-风雨知音lhm-三级", // 广告主名称
          owner_id: "1000476230",
          api_id: "0b8031f4c2cb42979d5ab1073d7ced06",
          api_key: "db20619cb93342e29191af3639e17c15"
        },
        {
          advName: "SMBHEF-肥猫小说-三级", // 广告主名称
          owner_id: "1000403962",
          api_id: "13540deea831433681fd83f2506a90dd",
          api_key: "af668c5760ce4889a6485b605f6370c6"
        },
        {
          advName: "SMBHEF-肥猫测评-三级", // 广告主名称
          owner_id: "1000403942",
          api_id: "2850ac52b874418b997c17b3e641b6ea",
          api_key: "ff8309a2edf7405899fdd580cb315f0e"
        },
        {
          advName: "SMBHEF-爱测评-三级", // 广告主名称
          owner_id: "1000403941",
          api_id: "4ccac53f1e2840f2b319621ff5e0e605",
          api_key: "5d5d9f54da6b46ccb37f3ec10c21b304"
        },

        {
          advName: "SMBHEF-夸克-2-三级", // 广告主名称
          owner_id: "1000500258",
          api_id: "871867b764ff442196b1c7275f9c1f8c",
          api_key: "a059a1b111754bf18c2b667d2d9513f9"
        },
        {
          advName: "SMBHEF-夸克-三级", // 广告主名称
          owner_id: "1000467691",
          api_id: "29ca739964b545099ceb2ed4310f0404",
          api_key: "598842be8a304dfeaeac303b4a1f5dcb"
        },

        {
          advName: "SMBHEF-UC-三级", // 广告主名称
          owner_id: "1000467687",
          api_id: "ded3296cbdbc42b5b03a5a39e6dc6743",
          api_key: "53fbd8416a1c4649b671b45babb7434b"
        },
        {
          advName: "HN-微驰互动-二代商店", // 广告主名称
          owner_id: "1001139543",
          api_id: "07bc874021574bf199f14d4963f78cb7",
          api_key: "62be367bbd574b80a48e2f9109782307"
        },
        {
          advName: "微驰互动-二代 ", // 广告主名称
          owner_id: "1001156946",
          api_id: "2e82baccc62a43ecbff8617271105a3d",
          api_key: "5be6abd0a35b429b84b62022fd042150"
        },



      ];
// 通用的请求逻辑，动态生成请求体
      const fetchAdvertiserData = (advertisersList, type) => {
        return advertisersList.map(advertiser => {
          const requestBody = type === 'advertisers' ? {
            page: 1,
            pageCount: 100,
            beginTime: this.formatDate(this.beginTime),
            endTime: this.formatDate(this.endTime),
            timeLevel: this.timeLevel,
            orderByColumns: "owner_id",
            ascDesc: "ASC",
            paraMap: {
              subAccList: ["1", "0", "9999"],
                owner_type: "3",
              extensionFlowList: ["1", "2","3"],
              flowSceneList: ["0","1", "2","3","4","5","6", "7", "8", "9", "10", "11","12","13","14","15"],
              groupByColumn: "owner_id,sub_acc,extension_flow"
            }
          } : {
            page: 1,
            pageCount: 100,
            beginTime: this.formatDate(this.beginTime),
            endTime: this.formatDate(this.endTime),
            timeLevel: this.timeLevel,
            orderByColumns: "owner_id",
            ascDesc: "ASC",
            paraMap: {
              subAccList: ["1", "0", "9999"],
              owner_type: "0",
              extensionFlowList: ["1", "2","3"],
              flowSceneList: ["0","1", "2","3","4","5","6", "7", "8", "9", "10", "11","12","13","14","15"],
              groupByColumn: "owner_id,sub_acc,extension_flow"
            }

          };

          const token = this.generateToken(advertiser.owner_id, advertiser.api_id, advertiser.api_key); // 生成token

          // 设置请求头
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          };

          // 返回Promise以便后续处理
          return this.$axios.post('apis/v3/data/common/agency/query/queryOwnerCost', requestBody, { headers })
            .then(response => {
              // 将广告主名称与返回的items合并
              const items = response.data.data.items || []; // 确保items存在
              return items.map(item => ({
                ...item,
                edowner_id: advertiser.owner_id,
                advName: advertiser.advName, // 将广告主名称添加到每个项目中
                cost: item.cost / 100 // 将cost从分转换为元
              }));
            });
        });
      };

// 分别处理两个广告主列表
      const advertiserRequests = fetchAdvertiserData(advertisers, 'advertisers');
      const zzhRequests = fetchAdvertiserData(zzh, 'zzh');

// 合并所有请求
      const allRequests = [...advertiserRequests, ...zzhRequests];

// 使用Promise.all处理所有请求
      Promise.all(allRequests)
        .then(results => {
          // 将所有结果扁平化并存储到responseData中
          this.responseData = results.flat(); // 扁平化数组
        })
        .catch(error => {
          console.error("Error fetching data:", error);
        });
    }
  }
};
</script>
<style scoped>
.query-form {
  margin-bottom: 20px;
}
.form-item {
  margin-bottom: 0; /* 去掉每个表单项的底部间距 */
}
.query-button {
  width: 100%; /* 使按钮宽度占满 */
}
</style>






// WEBPACK FOOTER //
// src/components/login/oppoAll.vue